// Many editions are titled with their own code (e.g. "December 2020 A"), which
// would render the same string twice on the card.
export const getEditionCardLine3 = (
	line2: string | null | undefined,
	line3: string | null | undefined
): string => {
	const candidate = line3 || '';

	return candidate === (line2 || '') ? '' : candidate;
};
